export const API_URL: string = "https://michelle.kkode.site";
